<template>
  <div class="qrcode">

    <div v-for="item in list" :v-bind="item.id"  >
      <span>{{item.name}}</span>

      <div :id="'qrcode'+item.id" ></div>
      <span>
        <label>{{item.type}}</label>
        <label>{{item.time}}-{{item.id}}</label>
      </span>
      <!--/<span>{{item.time}}</span>-->
    </div>
    <!--<div id="qrcode"></div>-->
    <!--<el-button type="primary" icon="el-icon-circle-plus" @click="printQR2" >打印二维码</el-button>-->

  </div>
</template>
<script>
  import QRCode from 'qrcodejs2'
  export default {
    name: "QRCodePrinter",
    mounted() {
      // if (this.$route.params) {
      // this.active = this.$route.params.id;
      // this.init();
      let list=[];
      if (this.$route.query){
        let q=this.$route.query;
        console.log("=====",q.start,q.end);
        let s=parseInt(q.start)
        let e=parseInt(q.end)

        for (let i=s;i<=e;i++){
        // for (let i=2;i<=12;i++){
          // let s=q.time+'-'+q.id+'-'+q.type+'-'+i+"|"+q.name
          let s=this.makeCode(q.id,q.name,q.type,i)
          list.push({name:q.name,time:q.time,type:q.type==1?'感染性':'损伤性',code:s,id:i});
          console.log("-->",s);
        }
      }
      this.list=list;
      let $this=this;
      setTimeout(function(){
        for (let i=0;i<list.length;i++){
          $this.printQR(list[i].code,"qrcode"+list[i].id)
        }
      },1);
      console.log("Load::",this.$route.query)
      console.log(this.$route)
      // }
    },
    data() {
      return {
        list:[],
      }
    },
    methods: {

      // watch: {
      //   $route(to, from) {
      //
      //     console.log("$route::",to,from)
      //
      //     //监听路由是否变化
      //     // if (to.params.id != from.params.id) {
      //       // this.active = to.params.id;
      //       // this.init();//重新加载数据
      //     // }
      //   }
      // },
      printQR(code,name){
        //QRCode();
        console.log("--------",name,code)

        var qr =new QRCode(name,{text:code,width:160,height:160});
        console.log("printing ...",document.getElementById(name));

        console.log("---122211111--");
        // qr.makeCode("201113-1-1-1");
      },
      printQR2(){
        let list=this.list
        for (let i=0;i<list.length;i++){
          this.printQR(list[i].code,"qrcode"+list[i].id)
        }
      },
      printQR1(){
        //QRCode();
        var qr =new QRCode("qrcode",this.makeCode(101,"乐山市人民医院",1,1));
        console.log("printing ...",QRCode ,typeof QRCode,document.getElementById("qrcode"));

        console.log("---122211--");
        // qr.makeCode("201113-1-1-1");
      },
      makeCode(id,name,t,num){
        return this.getTime()+"-"+id +"-"+t+"-"+num+"|"+name
      },
      getTime(){
        var t =new Date();
        return this.appendZero(t.getFullYear()%100)+""+this.appendZero(t.getMonth()+1)+this.appendZero(t.getDate())
      },
      appendZero(obj) {
        if (obj < 10) {
          return "0" + obj;
        } else {
          return obj;
        }
      }
    }
  }
</script>

<style scoped>
  .qrcode{
    width: 910px;
    text-align: left;
  }
  .qrcode>div{
      display: inline-block;
    width: 180px;
    height: 270px;
    margin-right:24px;
    margin-top: 25px;
    padding-left: 10px;
    padding-right: 10px;
    border: 1px solid #ccc;
  }
  .qrcode>div:last-child{margin-right: 0 !important;}
  .qrcode>div>span{display: block;width: 100%}

  .qrcode>div>span>label:last-child{display: inline-block;text-align: right;width: calc(100% - 60px)}
  .qrcode>div>span>label:first-child{display: inline-block;width: 50px}
  .qrcode>div>div{margin-top: 5px;margin-bottom: 5px;margin-left: 10px}


</style>



// WEBPACK FOOTER //
// src/view/qrCode.vue